export default __webpack_public_path__ + "static/media/twitter.42d80b04.svg";